'use client'

import type {ReactNode} from 'react'
import Link, {useLinkStatus} from 'next/link'
import {ArrowLeft} from 'lucide-react'
import {LoadingSpinner} from '@fitro/customer-ui/LoadingSpinner'
import {useTranslation} from '../../../hooks/useTranslation'
import {publicEntryStyles} from './publicEntryStyles'

function BackLinkStatus() {
    const {pending} = useLinkStatus()
    const {t} = useTranslation('landing')
    return pending
        ? <LoadingSpinner size="sm" className="shrink-0 !text-current" aria-label={t('publicEntry.loading')}/>
        : <ArrowLeft className="h-4 w-4 shrink-0" aria-hidden="true"/>
}

export function PublicOfferBackLink({href, children}: {href: string; children: ReactNode}) {
    return (
        <Link href={href} className={publicEntryStyles.detailBackLink}>
            <BackLinkStatus/>
            {children}
        </Link>
    )
}
